import store from "../../../store";
import equipment_editor from './equipment_editor.vue';
import equipment_act from "./equipment_act.vue";

window.INSTRUCTIONS =  new Vue({
    store,
    el: '#equipment_editor',
    name : "Equipment",
    created () {

    },
    components : {
        equipment_editor,
        equipment_act
    }
})
